import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Calendar, MapPin, Bed } from 'lucide-react';
import { useBooking } from '../hooks/useBooking';
interface ConfirmationProps {
  onHome: () => void;
}
export function Confirmation({
  onHome
}: ConfirmationProps) {
  const {
    selectedHotel,
    selectedRoom,
    checkIn,
    checkOut,
    resetBooking
  } = useBooking();
  // Generate a random booking reference
  const bookingRef = Math.random().toString(36).substring(2, 10).toUpperCase();
  const formatDate = (date: Date | null) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  const handleHome = () => {
    resetBooking();
    onHome();
  };
  // If accessed directly without booking, redirect home
  useEffect(() => {
    if (!selectedHotel) {
      handleHome();
    }
  }, []);
  if (!selectedHotel || !selectedRoom) return null;
  return <div className="pt-32 pb-20 min-h-screen bg-luxury-cream flex items-center justify-center" data-id="element-260">
      <div className="max-w-2xl w-full mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-float border border-gray-100 text-center" data-id="element-262">
          <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-263">
            <CheckCircle className="w-10 h-10 text-green-500" data-id="element-264" />
          </div>

          <h1 className="text-4xl font-italiana text-luxury-slate mb-2" data-id="element-265">
            Booking Confirmed!
          </h1>
          <p className="text-gray-500 mb-8" data-id="element-266">
            A confirmation email has been sent to your inbox.
          </p>

          <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-left" data-id="element-267">
            <div className="flex justify-between items-center border-b border-gray-200 pb-4 mb-4" data-id="element-268">
              <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-269">
                Booking Reference
              </span>
              <span className="font-mono font-bold text-luxury-slate" data-id="element-270">
                {bookingRef}
              </span>
            </div>

            <div className="space-y-4" data-id="element-271">
              <div className="flex items-start gap-3" data-id="element-272">
                <MapPin className="w-5 h-5 text-luxury-blue shrink-0 mt-0.5" data-id="element-273" />
                <div data-id="element-274">
                  <div className="font-semibold text-gray-900" data-id="element-275">
                    {selectedHotel.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-276">
                    {selectedHotel.location}
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-277">
                <Bed className="w-5 h-5 text-luxury-blue shrink-0 mt-0.5" data-id="element-278" />
                <div className="font-medium text-gray-900" data-id="element-279">
                  {selectedRoom.name}
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-280">
                <Calendar className="w-5 h-5 text-luxury-blue shrink-0 mt-0.5" data-id="element-281" />
                <div className="font-medium text-gray-900" data-id="element-282">
                  {formatDate(checkIn)} — {formatDate(checkOut)}
                </div>
              </div>
            </div>
          </div>

          <button onClick={handleHome} className="bg-luxury-slate hover:bg-gray-800 text-white px-8 py-4 rounded-xl font-semibold transition-colors shadow-md inline-flex items-center" data-id="element-283">
            Return to Homepage
          </button>
        </motion.div>
      </div>
    </div>;
}